import { useEffect, useState } from 'react';
import { useSessionGuard } from "./useSessionGuard";
import { CHECK_SESSION_INTERVAL } from '~/helpers/constants';

interface UseSessionHeartbeatOptions {
  checkWhenHidden?: boolean;
}

export const useSessionHeartbeat = (options: UseSessionHeartbeatOptions = {}) => {
  const { checkWhenHidden = false } = options;
  const [isVisible, setIsVisible] = useState(!document.hidden);
  const { checkSessionBeforeAction } = useSessionGuard();
  const POLLING_INTERVAL = CHECK_SESSION_INTERVAL[5];

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsVisible(!document.hidden);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  useEffect(() => {
    // Se checkWhenHidden for false e a aba não estiver visível, não faz nada
    if (!checkWhenHidden && !isVisible) return;

    const checkSession = async () => {
      await checkSessionBeforeAction();
    };

    const interval = setInterval(checkSession, POLLING_INTERVAL);

    return () => clearInterval(interval);
  }, [isVisible, checkWhenHidden, checkSessionBeforeAction]);
};

